var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningInfoNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 16.2697C11.25 15.8557 11.586 15.5137 12 15.5137C12.414 15.5137 12.75 15.8447 12.75 16.2587V16.2697C12.75 16.6837 12.414 17.0197 12 17.0197C11.586 17.0197 11.25 16.6837 11.25 16.2697Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79535 20.418H19.2774C20.4244 20.358 21.3064 19.381 21.2474 18.234C21.2344 18.002 21.1844 17.773 21.0964 17.559L13.8194 4.82298C13.2634 3.81798 11.9984 3.45398 10.9934 4.01098C10.6514 4.19898 10.3694 4.48098 10.1804 4.82298L2.90335 17.559C2.47135 18.623 2.98335 19.835 4.04635 20.268C4.26235 20.355 4.49035 20.405 4.72235 20.418",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9893 13.3961V10.2961",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningInfoNotification);
export default __webpack_public_path__ + "static/media/Warning_info_notification.5e94fafb.svg";
export { ForwardRef as ReactComponent };